import { Link } from "react-router-dom";
import { PAYMENT } from "@/constants/testIds";

export default function PaymentCancel() {
  return (
    <div className="pt-32 pb-32 min-h-screen flex items-center">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold">Checkout paused</p>
        <h1 data-testid={PAYMENT.cancelHeading} className="mt-4 font-serif text-5xl md:text-6xl font-light tracking-tighter text-[#1A1C1A]">
          No worries. Come <em className="italic text-stone-600">back anytime</em>.
        </h1>
        <p className="mt-6 text-stone-600 font-light">Your cart is saved.</p>
        <div className="mt-10 flex gap-3 justify-center">
          <Link
            to="/cart"
            className="inline-block bg-[#1A1C1A] text-[#F9F9F6] hover:bg-[#3C3E3C] px-8 py-3.5 rounded-full font-sans text-sm tracking-wider uppercase"
          >
            Return to Cart
          </Link>
          <Link
            to="/shop"
            className="inline-block border border-[#1A1C1A]/70 text-[#1A1C1A] hover:bg-[#F4F1EA] px-8 py-3.5 rounded-full font-sans text-sm tracking-wider uppercase"
          >
            Keep Browsing
          </Link>
        </div>
      </div>
    </div>
  );
}
